import React, { useState } from 'react';
import collectionsData from '../../collections/collections.json';

export default function ApiCollections({ onRequestSelect }) {
  const [expandedFolders, setExpandedFolders] = useState({});

  const toggleFolder = (folderName) => {
    setExpandedFolders((prev) => ({
      ...prev,
      [folderName]: !prev[folderName],
    }));
  };

  const handleRequestClick = (request) => {
    onRequestSelect(request); // Pass the entire request object
  };

  return (
    <div className="w-1/5 bg-gray-100 h-screen overflow-y-auto border-r border-gray-300">
      {collectionsData.collections.map((collection, index) => (
        <div key={index} className="mb-4">
          <h1 className="px-4 py-2 font-bold text-[#fdb814]">{collection.name}</h1>
          {collection.folders.map((folder, folderIndex) => (
            <div key={folderIndex}>
              <button
                className="w-full text-left px-4 py-2 flex justify-between items-center hover:bg-gray-200"
                onClick={() => toggleFolder(folder.name)}
              >
                <span>{folder.name}</span>
                <span>{expandedFolders[folder.name] ? '▼' : '▶'}</span>
              </button>
              {expandedFolders[folder.name] && (
                <ul className="pl-6">
                  {folder.requests.map((request, reqIndex) => (
                    <li
                      key={reqIndex}
                      className="px-4 py-2 hover:bg-gray-300 cursor-pointer"
                      onClick={() => handleRequestClick(request)}
                    >
                      <span className="font-semibold text-[#fdb814]">{request.method}</span> {request.name}
                    </li>
                  ))}
                </ul>
              )}
            </div>
          ))}
        </div>
      ))}
    </div>
  );
}